<template>
  <section class="row shadow-none">
    <div class="col">
      <div v-if="whichIsActive == 'purchaseOrder'" :class="['be-loading', { 'be-loading-active': isBusy }]">
        <div class="w-full flex flex-col justify-start items-start gap-[16px] mb-[16px]">
          <button
            class="text-[14px] font-semibold leading-[20px] cursor-pointer focus:outline-none py-[5px] border-b-2 border-[#2463EB] text-[#2463EB]">
            Purchase Order
          </button>
          <div
            class="flex xs:flex-col md:flex-row xs:justify-start md:justify-between w-full xs:items-start xs:gap-4 lg-gap-2 md:items-center">
            <p class="text-[#353535] text-[14px] leading-[20px] font-semibold">
              Purchase Order
            </p>
            <div class="flex gap-3 flex-wrap xs:justify-start lg:justify-center xs:items-start lg:items-center">
              <button @click="filter"
                class="border-[1px] border-[#96a0b5] rounded-[8px] text-[#96a0b5] font-normal text-[14px] border-solid px-[24px] py-[12px] outline-none focus:outline-none">
                <span class="feather icon-filter text-[#96a0b5]"></span> Filters
              </button>
              <button @click="newOrder"
                class="border-[1px] bg-[#2463eb] rounded-[8px] text-white font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] outline-none focus:outline-none">
                <span class="feather icon-plus text-white"></span> New Order
              </button>
            </div>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table m-0 p-0 table-fw-widget dataTable no-footer text-nowrap" :class="purchaseOrders.length > 1 ? 'min-h-[190px]' : 'min-h-[300px]'
            ">
            <thead style="background-color: #f4f4f4">
              <tr>
                <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
                  PO Number
                </th>
                <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
                  Order Amount
                </th>
                <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
                  SAP Number
                </th>
                <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
                  Order Status
                </th>
                <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
                  Creation Date
                </th>
                <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
                  Approval Date
                </th>
                <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading">
                <td colspan="12" class="text-center">
                  <div class="text-center" style="padding-top: 100px; padding-bottom: 50px">
                    <span class="fa-solid fa-spinner fa-spin text-[#2463EB]" style="font-size: 8rem"></span>
                    <h3 class="text-center pt-[24px] text-[16px] font-medium leading-[16.94px]"
                      style="padding-bottom: 100px">
                      Please wait while we loading the sales orders
                    </h3>
                  </div>
                </td>
              </tr>
              <tr v-for="po in purchaseOrders" :key="po.id" v-else>
                <td>
                  {{ po.orderNumber }}
                </td>
                <Amount :details="po.details" />
                <td class="text-[14px] font-normal leading-[16.94px]">
                  {{ getSapInfo(po) }}
                </td>
                <td>
                  <span class="flex items-center gap-[5px] max-w-max w-fullpx-[5px]" :class="[
                    'badge',
                    { 'badge-success': getStatus(po.status) === 'approved' },
                    { 'badge-danger': getStatus(po.status) === 'rejected' },
                    {
                      'badge-secondary':
                        getStatus(po.status) === 'closed' || 'draft',
                    },
                    { 'badge-warning': getStatus(po.status) === 'submitted' },
                  ]">
                    <span class="inline-block w-[10px] h-[10px] rounded-[1px]" :style="{
                      backgroundColor:
                        getStatus(po.status) === 'approved'
                          ? '#16a249'
                          : getStatus(po.status) === 'submitted'
                            ? '#FFA500'
                            : getStatus(po.status) === 'rejected'
                              ? '#e42728'
                              : getStatus(po.status) === 'closed' || 'draft'
                                ? '#ccc'
                                : '',
                    }"></span>
                    <span class="text-[12px] font-normal leading-[16.94px]">
                      {{
                        getStatus(po.status) === "approved"
                          ? "Approved"
                          : getStatus(po.status) === "closed"
                            ? "Closed"
                            : getStatus(po.status) === "submitted"
                              ? "Submitted"
                              : getStatus(po.status) === "rejected"
                                ? "Rejected"
                                : getStatus(po.status) === "draft"
                                  ? "Draft"
                                  : getStatus(po.status)
                      }}
                    </span>
                  </span>
                </td>
                <td>
                  {{ formatDate(po.created) }}
                </td>
                <td>
                  {{
                    formatDate(po.approvedAt)
                      ? formatDate(po.approvedAt)
                      : "***"
                  }}
                </td>
                <td @click="toggleDropdown(po.id)">
                  <div class="dropdown">
                    <button class="btn-no-border" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                      aria-expanded="false">
                      <span
                        class="text-[#98a2b3] dropdown text-2xl cursor-pointer relative outline-none active:outline-none shadow-none">
                        ...
                      </span>
                    </button>
                    <ul class="dropdown-menu shadow-none" aria-labelledby="dropdownMenuButton">
                      <li
                        class="text-[14px] font-normal leading-[14px] text-[#353535] cursor-pointer py-[10px] px-[16px]"
                        :class="{
                          'border-b border-[#e5e7eb]':
                            po.status !== 'CLOSED' &&
                            po.status !== 'approved' &&
                            po.status !== 'rejected' &&
                            (po.status === 'draft' ||
                              po.status === 'submitted'),
                        }" @click.prevent="viewOrder(po.id, po.orderNumber)">
                        View Order
                      </li>
                      <li v-if="
                        po.status !== 'CLOSED' &&
                        po.status !== 'approved' &&
                        po.status !== 'rejected'
                      "
                        class="text-[14px] font-normal leading-[14px] text-[#353535] cursor-pointer py-[10px] px-[16px]"
                        :class="{
                          'border-b border-[#e5e7eb]':
                            po.status === 'draft' || po.status === 'submitted',
                        }" @click.prevent="viewEdit(po.id)">
                        Edit Order
                      </li>
                      <li v-if="po.status === 'draft'"
                        class="text-[14px] font-normal leading-[14px] text-[#353535] cursor-pointer py-[10px] px-[16px]"
                        :class="{
                          'border-b border-[#e5e7eb]':
                            po.status !== 'submitted',
                        }">
                        <SubmitPurchaseOrder :purchaseOrder="po" :onComplete="onActionComplete"
                          @showAction="onShowAction" :ref="po.id" />
                      </li>
                      <li v-if="
                        po.status === 'draft' || po.status === 'submitted'
                      "
                        class="text-[14px] font-normal leading-[14px] text-[#353535] cursor-pointer py-[10px] px-[16px]">
                        <DeletePurchaseOrder :purchaseOrder="po" @onComplete="onActionComplete"
                          @showAction="onShowAction" :ref="po.id" />
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
              <tr v-if="!purchaseOrders.length && !loading">
                <td colspan="7">
                  <div class="text-center" style="padding-top: 50px">
                    <span style="font-size: 4.615rem" class="mdi mdi-tag-multiple"></span>
                  </div>
                  <h3 class="text-center" style="padding-bottom: 100px">
                    No Purchase Found.
                  </h3>
                </td>
              </tr>
            </tbody>
          </table>
          <Pagination :limit="pageSize" :count="pageCount" :page="pageNumber" :itemsCount="count" @changePage="gotoPage"
            @changeLimit="changeLimit" />
        </div>
      </div>
      <div v-if="whichIsActive == 'payForOrder'">
        <div :class="[
          'card',
          'card-border-color',
          'card-border-color-primary',
          'card-table',
          'be-loading',
          { 'be-loading-active': isBusy },
        ]">
          <div class="card-header">
            <div>
              <h4>
                <b> PO Number - {{ orderNumber }} </b>
              </h4>
              <p>Purchase Order for {{ user.displayName }}</p>
            </div>
            <div>
              <h4 class="text-uppercase">
                <b>Payment Status -
                  {{ paymentStatus ? paymentStatus : "Nill" }}</b>
              </h4>
            </div>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-hover table-sm">
                <thead class="thead-light">
                  <tr>
                    <th scope="col">Item #</th>
                    <th scope="col">Description</th>
                    <th scope="col">Quantity</th>
                    <th class="tc-width" scope="col ">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(oD, index) in orderDetails" :key="oD.id">
                    <td>{{ index + 1 }}</td>
                    <td>{{ oD.description }}</td>
                    <td>{{ oD.quantity }}</td>
                    <td>&#8358;{{ formatMoney(oD.quantity * oD.price) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col mt-2">
              <div class="row justify-content-end">
                <div class="w-custom">
                  <div class="row">
                    <div class="col-6 pd-0 text-right">
                      <b class="text-right">Sub-total&nbsp;-&nbsp;</b>
                    </div>
                    <div class="col-6 pd-0">
                      <p class="">&#8358; {{ formatMoney(total) }}</p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6 pd-0 text-right">
                      <b class="text-right">Amount Paid&nbsp;-&nbsp;</b>
                    </div>
                    <div class="col-6 pd-0">
                      <p class="">&#8358; {{ formatMoney(amountPaid) }}</p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6 pd-0 text-right">
                      <b class="text-right">Balance Payable&nbsp;-&nbsp;</b>
                    </div>
                    <div class="col-6 pd-0">
                      <p class="">
                        &#8358; {{ formatMoney(total - amountPaid) }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="w-100 mb-5">
          <div class="float-right">
            <div class="d-flex justify-content-between">
              <button class="btn float-right mr-2" @click="setWhichisActive('purchaseOrder')">
                Cancel
              </button>
              <button class="btn btn-primary btn-rounded btn-space float-right"
                @click="setWhichisActive('makePayment')">
                Proceed to Payments
              </button>
            </div>
          </div>
        </div>
      </div>
      <div v-if="whichIsActive == 'makePayment'">
        <button class="btn btn-danger mb-2" @click="setWhichisActive('payForOrder')">
          <span class="feather icon-arrow-left text-white"></span>
          Back to order details
        </button>
        <div :class="[
          'card',
          'card-border-color',
          'card-border-color-primary',
          'card-table',
          'be-loading',
          { 'be-loading-active': isBusy },
        ]">
          <div class="card-header">
            <span>
              <h4>
                <b>PO Number - {{ orderNumber }}</b>
              </h4>
              <p>Purchase Order for {{ user.displayName }}</p>
            </span>
          </div>
          <div class="card-body px-3">
            <p>PURCHASE ORDER AMOUNT</p>
            <h1 class="my-2">&#8358;{{ formatMoney(total) }}</h1>
            <div class="w-50">
              <div class="form-check form-check-inline w-50">
                <input class="form-check-input" name="full" type="radio" value="full" v-model.trim="paymentPattern"
                  :disabled="total - amountPaid == 0" />
                <label class="form-check-label">Make full payment</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" name="part" type="radio" id="inlineCheckbox2" value="part"
                  v-model="paymentPattern" :disabled="total - amountPaid == 0" />
                <label class="form-check-label" for="inlineCheckbox2">Make part payment</label>
              </div>
            </div>
            <div v-if="paymentPattern == 'part'" class="form-group row my-3">
              <label class="col-12 col-sm-3 col-form-label">Enter Amount</label>
              <div class="col-12 col-sm-8 col-lg-4">
                <input class="form-control" type="number" placeholder="Enter Amount" v-model="amountToPaid"
                  @input="validateInput" :class="{ 'is-invalid': hasError }" :disabled="total - amountPaid == 0" />
                <p v-if="hasError" class="error-message text-danger">
                  Please enter a valid number
                </p>
              </div>
            </div>
          </div>
        </div>
        <div :class="[
          'mb-2',
          'card',
          'card-border-color',
          'card-border-color-primary',
          'card-table',
          'be-loading',
          { 'be-loading-active': isBusy },
        ]">
          <div class="card-header">
            <span>
              <h4><b>Payment</b></h4>
            </span>
          </div>
          <div class="card-body">
            <p class="text-primary cursor" @click="showLearnMoreModal">
              <span class="feather icon-alert-circle text-primary"></span>
              Learn more about payments
            </p>
            <div class="form-group row">
              <label class="col-12 col-sm-3 col-form-label">Payment Method</label>
              <div class="col-xl-4 col-sm-12 col-md-7 col-lg-6">
                <div class="dropdown">
                  <button class="w-100 p-1 btn btn-outline-primary btn-custom dropdown-toggle" type="button"
                    id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {{ paymentMethod }}
                  </button>
                  <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <div class="row p-05 c-cursor" @click="selectPaymentMethod('Use Creditline')">
                      <p class="m-0">Use Creditline</p>
                    </div>
                    <div class="row p-05 c-cursor" @click="selectPaymentMethod('Submit Payment Receipt')">
                      <p class="m-0">Submit Payment Receipt</p>
                    </div>
                    <div class="row p-05 justify-content-between c-cursor">
                      <p class="m-0">Buy now pay later</p>
                      <span class="text-primary">COMING SOON
                        <img class="mx-1" src="../../../public/assets/icon/history.svg" /></span>
                    </div>
                    <div class="row p-05 justify-content-between c-cursor">
                      <p class="m-0">Pay With Transfer</p>
                      <span class="text-primary">COMING SOON
                        <img class="mx-1" src="../../../public/assets/icon/history.svg" /></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button class="btn btn-primary float-right mb-5"
          :disabled="paymentMethod == 'Select Payment Method' && !amountToPaid" @click="triggerPayment">
          Next
        </button>
      </div>
      <div v-if="whichIsActive == 'paymentResult'">
        <div :class="[
          'card',
          'card-border-color',
          'card-border-color-primary',
          'card-table',
          'be-loading',
          { 'be-loading-active': isBusy },
        ]">
          <div class="card-header">
            <span>
              <h4>
                <b>Transaction Summary</b>
              </h4>
            </span>
          </div>
          <div class="card-body px-3">
            <h4><b>Your payment was successful</b></h4>
            <br />
            <p>
              <span>You paid &nbsp; &nbsp; &nbsp; &nbsp;</span>
              <b>{{
                initiattedPayment.amountPaid
                  ? initiattedPayment.amountPaid
                  : "Nill"
              }}</b>
            </p>
            <p>
              <span>PO no. &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span>
              <b>{{
                initiattedPayment.purchaseOrderNumber
                  ? initiattedPayment.purchaseOrderNumber
                  : "Nill"
              }}</b>
            </p>
          </div>
        </div>
        <div :class="[
          'card',
          'card-border-color',
          'card-border-color-primary',
          'card-table',
          'be-loading',
          { 'be-loading-active': isBusy },
        ]">
          <div class="card-header">
            <span>
              <h4><b>Payment</b></h4>
            </span>
          </div>
          <div class="card-body px-3">
            <h4>
              <b>Payment Method -
                {{
                  initiattedPayment.paymentMethod
                    ? initiattedPayment.paymentMethod
                    : "Nill"
                }}</b>
            </h4>
            <br />
            <div class="timelinex block">
              <div class="tl-item">
                <div :class="initiateStagetimelineClass"></div>
                <div class="tl-content">
                  <span><b>{{
                    formatDate(initiattedPayment.initiatedDate)
                      ? formatDate(initiattedPayment.initiatedDate)
                      : "Nill"
                  }}</b></span>
                  <div class="tl-date text-muted">
                    <p>
                      You Initiated a payment of
                      <span><b>{{
                        initiattedPayment.amountPaid
                          ? initiattedPayment.amountPaid
                          : "Nill"
                      }}</b></span>
                    </p>
                  </div>
                </div>
              </div>
              <div class="tl-item">
                <!-- v-if="initiattedPayment.recievedDate != null" -->
                <div :class="confirmedStagetimelineClass"></div>
                <div class="tl-content">
                  <span><b>{{
                    formatDate(initiattedPayment.recievedDate)
                      ? formatDate(initiattedPayment.recievedDate)
                      : "Nill"
                  }}</b></span>
                  <div class="tl-date text-muted">
                    <p>
                      We recieved your payment
                      <span><b>{{
                        initiattedPayment.amountPaid
                          ? initiattedPayment.amountPaid
                          : "Nill"
                      }}</b></span>
                    </p>
                  </div>
                </div>
              </div>
              <div class="tl-item">
                <!-- v-if="initiattedPayment.recievedDate != null" -->
                <div :class="receivedStagetimelineClass"></div>
                <div class="tl-content">
                  <span><b>{{
                    formatDate(initiattedPayment.confirmdDate)
                      ? formatDate(initiattedPayment.confirmdDate)
                      : "Nill"
                  }}</b></span>
                  <div class="tl-date text-muted">
                    <p>Your Payment was confirmed successfully</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button class="btn btn-primary float-right mb-5" @click="reloadPage">
          Done
        </button>
      </div>
    </div>

    <div class="modal fade colored-header colored-header-primary" id="submitPaymentreceiptmodal" role="dialog">
      <div class="modal-dialog modal-dialog-scrollable lg-modal">
        <div class="modal-content">
          <div class="modal-header modal-header-colored">
            <h4 class="modal-title p-1">
              <strong>Submit Payment Receipt</strong>
            </h4>
            <button class="close md-close" type="button" data-dismiss="modal" aria-hidden="true">
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group row">
              <label class="col-12 col-sm-3 col-form-label text-sm-right">Amount</label>
              <div class="col-12 col-sm-8 col-lg-8">
                <input class="form-control" type="text" disabled v-model="paymentReceipt.amount" />
              </div>
            </div>
            <div class="form-group row">
              <label class="col-12 col-sm-3 col-form-label text-sm-right">Payment Date</label>
              <div class="col-12 col-sm-8 col-lg-8">
                <input class="form-control" type="date" placeholder="Enter Date" v-model="paymentReceipt.date" />
              </div>
            </div>
            <div class="form-group row">
              <label class="col-12 col-sm-3 col-form-label text-sm-right">Account number paid to</label>
              <div class="col-12 col-sm-8 col-lg-8">
                <input class="form-control" type="text" placeholder="Enter Account Number"
                  v-model="paymentReceipt.accountNumber" />
              </div>
            </div>
            <div class="form-group row">
              <label class="col-12 col-sm-3 col-form-label text-sm-right">Bank</label>
              <div class="col-12 col-sm-8 col-lg-8">
                <select class="form-control" placeholder="Select an option" v-model="paymentReceipt.bank">
                  <option v-for="b in banks" :key="b" :value="b">{{
                    b
                  }}</option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-12 col-sm-3 col-form-label text-sm-right">Account Name</label>
              <div class="col-12 col-sm-8 col-lg-8">
                <input class="form-control" type="text" placeholder="Enter Account Name"
                  v-model="paymentReceipt.accountName" />
              </div>
            </div>
            <div class="form-group row">
              <label class="col-12 col-sm-3 col-form-label text-sm-right">Depositors Name</label>
              <div class="col-12 col-sm-8 col-lg-8">
                <input class="form-control" type="text" placeholder="Enter Depositors Name"
                  v-model="paymentReceipt.depositorsName" />
              </div>
            </div>
            <div class="form-group row">
              <label class="col-12 col-sm-3 col-form-label text-sm-right">Description</label>
              <div class="col-12 col-sm-8 col-lg-8">
                <textarea class="form-control" placeholder="Enter Narration"
                  v-model="paymentReceipt.narration"></textarea>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button style="width: 100px" class="btn btn-secondary" type="button" data-dismiss="modal">
              Cancel
            </button>
            <button style="width: 160px" :disabled="isBusy == true" class="btn btn-primary" type="button"
              @click.prevent="recordPayment">
              <span v-if="isBusy">Busy...</span>
              <span v-else>Record Payment</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade colored-header colored-header-primary" id="submitCreditLinemodal" role="dialog">
      <div class="modal-dialog modal-dialog-scrollable lg-modal">
        <div class="modal-content">
          <div class="modal-header modal-header-colored">
            <h4 class="modal-title p-1"><strong>Credit Line</strong></h4>
            <button class="close md-close" type="button" data-dismiss="modal" aria-hidden="true">
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group row">
              <label class="col-12 col-sm-3 col-form-label text-sm-right">Amount</label>
              <div class="col-12 col-sm-8 col-lg-8">
                <input class="form-control" type="text" disabled v-model="creditLine.amount" />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button style="width: 100px" class="btn btn-secondary" type="button" data-dismiss="modal">
              Cancel
            </button>
            <button style="width: 160px" :disabled="isBusy == true" class="btn btn-primary" type="button"
              @click.prevent="recordPaymentCreditline">
              <span v-if="isBusy">Busy...</span>
              <span v-else>Confirm Payment</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade colored-header colored-header-primary" id="LearnMoreModal" role="dialog">
      <div class="modal-dialog modal-dialog-scrollable xl-modal">
        <div class="modal-content">
          <div class="modal-header modal-header-colored">
            <h3 class="modal-title p-1 text-primary">
              <strong>Payments</strong>
            </h3>
            <button class="close md-close" type="button" data-dismiss="modal" aria-hidden="true">
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body">
            <div>
              <h6 class="py-1"><strong>SUBMIT PAYMENT RECEIPT</strong></h6>
              <p>
                Use this option to submit the details of the transfer or deposit
                receipt of payments made for this order outside of the platform.
                Just so you know, you must have the receipt details of your
                payment..
              </p>
            </div>
            <div class="dropdown-divider"></div>
            <div>
              <h6 class="py-1"><strong>USE CREDITLINE</strong></h6>
              <p>
                Use this option to submit a request to make payments for your
                order from your "existing" credit facility with your supplier.
                Please note that your supplier may choose to accept or reject
                the request based on pre-existing credit/trade agreements
                between both of you.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ActionStatusModal :action="action" :purchaseNumber="purchaseNumber" @onDelete="perfomDelete"
      @onWithdraw="performWithdraw" @onSubmit="performSubmit" />
    <FilterPurchaseOrder @onFilter="performFiltering" />
    <viewSalesOrder v-if="isModalVisible" :closeModal="closeModal" :purchaseOrder="PurchaseOrder"
      :paymentHistory="paymentHistory" :viewEdit="viewEdit" :dataID="dataID" />
    <NewPurchaseOrder v-if="newOrderModal" :PurchaseOrder="purchaseOrders" :closeModal="closeNewModal" />
    <EditPurchaseOrder v-if="isEditModalVisible" :closeEditModal="closeEditModal" :orderId="orderID" />
  </section>
</template>

<script>
import { helper } from "@/helper";
import moment from "moment";

import Pagination from "../../components/Pagination.vue";
import ActionStatusModal from "../../components/PurchaseOrder/ActionStatusModal";
import DeletePurchaseOrder from "../../components/PurchaseOrder/DeletePurchaseOrder";
import FilterPurchaseOrder from "../../components/PurchaseOrder/FilterPurchaseOrder";
import SubmitPurchaseOrder from "../../components/PurchaseOrder/SubmitPurchaseOrder";
import SwitchPurchaseOrder from "../../components/PurchaseOrder/SwitchPurchaseOrder";
import Amount from "../../components/SettingsPurchaseOrder/Amount";
import SystemPermissions from "@/permissions";
import viewSalesOrder from "../../components/PurchaseOrder/viewSalesOrder.vue";
import NewPurchaseOrder from "../../components/PurchaseOrder/NewPurchaseOrder.vue";
import EditPurchaseOrder from "../../components/PurchaseOrder/EditPurchaseOrder.vue";
import { bus } from "../../main";

export default {
  mixins: [SystemPermissions.Mixin],
  name: "purchaseOrder",
  components: {
    DeletePurchaseOrder,
    SwitchPurchaseOrder,
    SubmitPurchaseOrder,
    ActionStatusModal,
    FilterPurchaseOrder,
    Amount,
    Pagination,
    viewSalesOrder,
    NewPurchaseOrder,
    EditPurchaseOrder,
  },

  created() {
    this.getPurchaseOrders();
    this.getOrderStages();
    this.setWhichisActive("purchaseOrder");
    bus.$on("orderFromNotification", this.orderFromNotification);
  },

  data() {
    return {
      isBusy: false,
      activeSubTab: "salesOrder",
      activeTab: "sales",
      count: 0,
      loading: true,
      pageNumber: 1,
      pageSize: 10,
      pageCount: 0,
      hasNext: false,
      hasPrev: false,
      purchaseOrders: [],
      status: "",
      orderStages: [],
      orderNumber: "",
      purchaseNumber: "",
      isModalVisible: false,
      isEditModalVisible: false,
      action: "",
      actionOwner: "",
      whichIsActive: "",
      orderDetails: [],
      orderID: "",
      paymentStatus: "",
      paymentPattern: "",
      paymentMethod: "Select Payment Method",
      paymentReceipt: {
        amount: null,
        date: "",
        accountNumber: "",
        bank: "",
        accountName: "",
        depositorsName: "",
        narration: "",
      },
      creditLine: {
        amount: null,
      },
      banks: helper.getBanks(),
      amountToPaid: null,
      initiattedPayment: {
        amountPaid: null,
        paymentMethod: "",
        initiatedDate: null,
        confirmdDate: null,
        purchaseOrderNumber: null,
        recievedDate: null,
        transactionStatus: "",
      },
      initiateStagetimelineClass: "",
      confirmedStagetimelineClass: "",
      receivedStagetimelineClass: "",
      innerCircle: "tl-dot-inner",
      paymentHistory: [],
      inputValue: "",
      hasError: false,
      amountPaid: null,
      balance: null,
      selectedOrder: null,
      selectedPurchaseOrder: [],
      PurchaseOrder: {},
      items: [],
      paymentHistory: [],
      newOrderModal: false,
      dataID: "",
    };
  },

  computed: {
    user: function () {
      return this.$store.state.currentUser;
    },
    total: function () {
      let amount = 0;
      this.orderDetails.forEach((i) => (amount += i.quantity * i.price));
      return amount;
    },
  },

  methods: {
    getSapInfo(order) {
      const orderStatus = order.status.toLocaleLowerCase();
      if (orderStatus === "rejected" || orderStatus === "cancelled") {
        return "***";
      }
      if (orderStatus === "submitted" || orderStatus === "draft") {
        return "Awaiting approval";
      }
      return order.sapSalesOrderNumber || "No SAP number";
    },
    async viewOrder(id) {
      this.dataID = id;
      this.isBusy = true;
      try {
        const response = await this.$http.get("/PurchaseOrders/view/" + id);
        if (response.ok) {
          const data = await response.json();
          this.PurchaseOrder = data;
          this.items = data.details;
          this.paymentHistory = response.body.paymentHistory;
          this.isModalVisible = true;
        }
        this.isBusy = false;
      } catch (error) {
        this.isBusy = false;
      }
      document.body.style.overflow = "hidden";
    },
    async orderFromNotification(id) {
      await this.viewOrder(id);
    },
    viewEdit(id) {
      this.orderID = id;
      this.isEditModalVisible = true;
      document.body.style.overflow = "hidden";
    },
    closeEditModal() {
      this.isEditModalVisible = false;
      document.body.style.overflow = "auto";
      this.closeModal();
      this.getPurchaseOrders();
    },
    newOrder() {
      this.newOrderModal = true;
      document.body.style.overflow = "hidden";
    },
    closeNewModal() {
      this.newOrderModal = false;
      document.body.style.overflow = "auto";
      this.getPurchaseOrders();
    },
    switchSubTab(subTab) {
      this.activeSubTab = subTab;
    },
    closeModal() {
      this.isModalVisible = false;
      document.body.style.overflow = "auto";
      this.getPurchaseOrders();
    },
    getStatus(status) {
      return status ? status.toLowerCase() : "";
    },
    checkPaymentStatus(x, y, z) {
      if (x === true) {
        this.initiateStagetimelineClass = "tl-dot";
      }
      if (x === false) {
        this.initiateStagetimelineClass = "tl-dot-danger";
      }
      if (x === null) {
        this.initiateStagetimelineClass = "tl-dot-gray";
      }

      if (y === true) {
        this.confirmedStagetimelineClass = "tl-dot";
      }
      if (y === false) {
        this.confirmedStagetimelineClass = "tl-dot-danger";
      }
      if (y === null) {
        this.confirmedStagetimelineClass = "tl-dot-gray";
      }

      if (z === true) {
        this.receivedStagetimelineClass = "tl-dot";
      }
      if (z === false) {
        this.receivedStagetimelineClass = "tl-dot-danger";
      }
      if (z === null) {
        this.receivedStagetimelineClass = "tl-dot-gray";
      }
    },
    validateInput() {
      this.hasError = /[^0-9]/g.test(this.inputValue);
      this.$emit("input", this.hasError ? null : parseFloat(this.inputValue));
    },
    showLearnMoreModal() {
      $("#LearnMoreModal").modal("show");
    },

    formatDate(date) {
      return moment(date).format("lll");
    },

    reloadPage() {
      window.location.reload();
    },
    toggleDropdown(userId) {
      this.showDropdown = this.showDropdown === userId ? null : userId;
    },

    async getOrderStages() {
      try {
        const response = await this.$http.get(
          "/PurchaseOrders/orderStage/getList?active=true"
        );

        if (response.ok && response.status === 200) {
          this.orderStages = response.body.sort(
            (firstItem, secondItem) => firstItem.stage - secondItem.stage
          );
        }
      } catch (error) { }
    },

    triggerPayment() {
      if (this.paymentPattern == "full") {
        this.creditLine.amount = this.balance;
        this.paymentReceipt.amount = this.balance;
      } else {
        this.creditLine.amount = this.amountToPaid;
        this.paymentReceipt.amount = this.amountToPaid;
      }
      if (this.paymentMethod == "Use Creditline") {
        $("#submitCreditLinemodal").modal("show");
      }
      if (this.paymentMethod == "Submit Payment Receipt") {
        $("#submitPaymentreceiptmodal").modal("show");
      }
    },

    async recordPayment() {
      let data = {
        orderId: this.orderID,
        paymentMethod: this.paymentMethod,
        amountPaid: this.paymentReceipt.amount,
        totalAmount: this.total,
        paymentDate: this.paymentReceipt.date,
        accountNumber: this.paymentReceipt.accountNumber,
        accountName: this.paymentReceipt.accountName,
        bankName: this.paymentReceipt.bank,
        depositorName: this.paymentReceipt.depositorsName,
        narration: this.paymentReceipt.narration,
      };
      this.isBusy = true;
      try {
        const response = await this.$http.post(
          "/PurchaseOrders/paymentReceipt",
          data
        );
        if (response.ok && response.status === 200) {
          this.$toast.success(response.message, {
            icon: false,
            rtl: false,
          });
        }
        $("#submitPaymentreceiptmodal").modal("hide");
        this.isBusy = false;
        (this.initiattedPayment.amountPaid = response.data.amountPaid),
          (this.initiattedPayment.paymentMethod = response.data.paymentMethod),
          (this.initiattedPayment.initiatedDate =
            response.data.initiateStage.date),
          (this.initiattedPayment.confirmedDate =
            response.data.confirmedStage.date),
          (this.initiattedPayment.purchaseOrderNumber =
            response.data.purchaseOrderNumber),
          (this.initiattedPayment.recievedDate =
            response.data.receivedStage.date),
          (this.initiattedPayment.transactionStatus =
            response.data.transactionStatus);
        this.checkPaymentStatus(
          response.data.initiateStage.status,
          response.data.confirmedStage.status,
          response.data.receivedStage.status
        );
        this.setWhichisActive("paymentResult");
      } catch (error) {
        this.isBusy = false;
        $("#submitPaymentreceiptmodal").modal("hide");
      }
    },

    async recordPaymentCreditline() {
      let data = {
        orderId: this.orderID,
        paymentMethod: this.paymentMethod,
        amountPaid: this.creditLine.amount,
        totalAmount: this.total,
      };
      this.isBusy = true;
      try {
        const response = await this.$http.post(
          "/PurchaseOrders/creditLine",
          data
        );
        if (response.ok && response.status === 200) {
          this.$toast.success(response.message, {
            icon: false,
            rtl: false,
          });
          (this.initiattedPayment.amountPaid = response.data.amountPaid),
            (this.initiattedPayment.paymentMethod =
              response.data.paymentMethod),
            (this.initiattedPayment.initiatedDate =
              response.data.initiateStage.date),
            (this.initiattedPayment.confirmedDate =
              response.data.confirmedStage.date),
            (this.initiattedPayment.purchaseOrderNumber =
              response.data.purchaseOrderNumber),
            (this.initiattedPayment.recievedDate =
              response.data.receivedStage.date),
            (this.initiattedPayment.transactionStatus =
              response.data.transactionStatus);
          this.checkPaymentStatus(
            response.data.initiateStage.status,
            response.data.confirmedStage.status,
            response.data.receivedStage.status
          );
          this.setWhichisActive("paymentResult");
        }
        $("#submitCreditLinemodal").modal("hide");
        this.isBusy = false;
      } catch (error) {
        this.isBusy = false;
        $("#submitCreditLinemodal").modal("hide");
      }
    },

    setWhichisActive(stage) {
      this.whichIsActive = stage;
    },

    selectPaymentMethod(selectedMethod) {
      this.paymentMethod = selectedMethod;
    },

    async payForOrder(orderID) {
      this.orderID = orderID;
      this.isBusy = true;
      try {
        const response = await this.$http.get(
          "/PurchaseOrders/view/" + orderID
        );
        if (response.ok) {
          this.details = response.body;
          this.orderDetails = response.body.details;
          this.orderNumber = response.body.orderNumber;
          this.paymentStatus = response.body.paymentStatus;
          this.paymentHistory = response.body.paymentHistory;
          this.balance = response.body.amountUnpaid;
          this.amountPaid = response.body.amountPaid;
          this.paymentHistory = response.body.paymentHistory;
        }
        this.setWhichisActive("payForOrder");
        this.isBusy = false;
      } catch (error) {
        this.isBusy = false;
      }
    },
    filter() {
      // eslint-disable-next-line no-undef
      this.pageNumber = 0;
      $("#mod-purchase-filter").modal("show");
    },

    onActionComplete() {
      this.getPurchaseOrders();
    },

    onShowAction(actionDetails) {
      this.purchaseNumber = actionDetails.purchaseNumber;
      this.action = actionDetails.action;
      this.actionOwner = actionDetails.owner;

      // eslint-disable-next-line no-undef
      $("#mod-action").modal("show");
    },

    hideAction() {
      // eslint-disable-next-line no-undef
      $("#mod-action").modal("hide");
    },

    editOrder(x) {
      console.log(x);
    },

    processOrder() {
      console.log("Edit");
    },

    cancelOrder() {
      console.log("Edit");
    },

    deleteOrder() {
      console.log("Edit");
    },

    async performFiltering(filteringOptions) {
      this.orderNumber = filteringOptions.orderNumber;
      this.status = filteringOptions.status;

      this.getPurchaseOrders();
      // eslint-disable-next-line no-undef
      $("#mod-purchase-filter").modal("hide");
    },

    async performSubmit() {
      this.hideAction();
      const component = this.$refs[this.actionOwner][0];
      component.switchPurchaseOrder();
      this.resetAction();
      this.closeModal();
    },

    async performWithdraw() {
      this.hideAction();
      const component = this.$refs[this.actionOwner][0];
      component.withdrawPurchase();
      this.resetAction();
    },

    async perfomDelete() {
      this.hideAction();
      const component = this.$refs[this.actionOwner][0];
      if (!component || typeof component.deletePurchaseOrder !== "function") {
        return;
      }
      component.deletePurchaseOrder();
      this.resetAction();
      this.closeModal();
    },

    resetAction() {
      this.purchaseNumber = "";
      this.action = "";
      this.actionOwner = "";
    },

    async getPurchaseOrders() {
      this.loading = true;
      this.isBusy = true;
      try {
        const response = await this.$http.get(
          "/PurchaseOrders/getList?OrderNumber=" +
          this.orderNumber +
          "&Status=" +
          this.status +
          "&PageNumber=" +
          this.pageNumber +
          "&PageSize=" +
          this.pageSize
        );

        if (response.ok && response.status === 200) {
          this.purchaseOrders = response.body.data;
          this.pageNumber = response.body.pageNumber;
          this.pageSize = response.body.pageSize;
          this.count = response.body.count;
          this.pageCount = Math.ceil(
            response.body.count / response.body.pageSize
          );
          this.hasPrev = response.body.hasPrev;
          this.hasNext = response.body.hasNext;
          this.isBusy = false;
          this.loading = false;
        }
      } catch (error) {
        this.isBusy = false;
        this.loading = false;
      }
    },

    formatDate(date) {
      if (date) return moment(date).format("lll");
      else return "";
    },

    formatMoney(val) {
      return helper.formatMoney(val);
    },

    prev() {
      this.pageNumber -= 1;
      this.getPurchaseOrders();
    },

    next() {
      this.pageNumber += 1;
      this.getPurchaseOrders();
    },

    gotoPage(page) {
      this.pageNumber = page - 1;
      this.getPurchaseOrders();
    },

    changeLimit(limit) {
      this.pageSize = limit;
      this.pageNumber = 1;
      this.getPurchaseOrders();
    },
  },
};
</script>
